import { jsx as r } from "react/jsx-runtime";
import { S as w } from "./chunks/index.CCavb-1K.js";
import "@smart/web-foundations";
import { c as d } from "./chunks/index.rKuIKazb.js";
import j from "react";
import { j as t, r as n, L as b } from "./chunks/layout.BROMuy9M.js";
import './assets/flex.css';const e = {
  "gap-0": "_gap-0_1vxyp_3",
  "gap-50": "_gap-50_1vxyp_6",
  "gap-100": "_gap-100_1vxyp_9",
  "gap-200": "_gap-200_1vxyp_12",
  "gap-300": "_gap-300_1vxyp_15",
  "gap-400": "_gap-400_1vxyp_18",
  "gap-500": "_gap-500_1vxyp_21",
  "gap-600": "_gap-600_1vxyp_24",
  "gap-700": "_gap-700_1vxyp_27",
  "gap-800": "_gap-800_1vxyp_30",
  "gap-900": "_gap-900_1vxyp_33",
  "gap-1000": "_gap-1000_1vxyp_36",
  "row-gap-0": "_row-gap-0_1vxyp_39",
  "row-gap-50": "_row-gap-50_1vxyp_42",
  "row-gap-100": "_row-gap-100_1vxyp_45",
  "row-gap-200": "_row-gap-200_1vxyp_48",
  "row-gap-300": "_row-gap-300_1vxyp_51",
  "row-gap-400": "_row-gap-400_1vxyp_54",
  "row-gap-500": "_row-gap-500_1vxyp_57",
  "row-gap-600": "_row-gap-600_1vxyp_60",
  "row-gap-700": "_row-gap-700_1vxyp_63",
  "row-gap-800": "_row-gap-800_1vxyp_66",
  "row-gap-900": "_row-gap-900_1vxyp_69",
  "row-gap-1000": "_row-gap-1000_1vxyp_72",
  "column-gap-0": "_column-gap-0_1vxyp_75",
  "column-gap-50": "_column-gap-50_1vxyp_78",
  "column-gap-100": "_column-gap-100_1vxyp_81",
  "column-gap-200": "_column-gap-200_1vxyp_84",
  "column-gap-300": "_column-gap-300_1vxyp_87",
  "column-gap-400": "_column-gap-400_1vxyp_90",
  "column-gap-500": "_column-gap-500_1vxyp_93",
  "column-gap-600": "_column-gap-600_1vxyp_96",
  "column-gap-700": "_column-gap-700_1vxyp_99",
  "column-gap-800": "_column-gap-800_1vxyp_102",
  "column-gap-900": "_column-gap-900_1vxyp_105",
  "column-gap-1000": "_column-gap-1000_1vxyp_108",
  "flex-direction-row": "_flex-direction-row_1vxyp_111",
  "flex-direction-row-reverse": "_flex-direction-row-reverse_1vxyp_114",
  "flex-direction-column": "_flex-direction-column_1vxyp_117",
  "flex-direction-column-reverse": "_flex-direction-column-reverse_1vxyp_120",
  "flex-direction-row-xs": "_flex-direction-row-xs_1vxyp_124",
  "flex-direction-row-reverse-xs": "_flex-direction-row-reverse-xs_1vxyp_129",
  "flex-direction-column-xs": "_flex-direction-column-xs_1vxyp_134",
  "flex-direction-column-reverse-xs": "_flex-direction-column-reverse-xs_1vxyp_139",
  "flex-direction-row-sm": "_flex-direction-row-sm_1vxyp_144",
  "flex-direction-row-reverse-sm": "_flex-direction-row-reverse-sm_1vxyp_149",
  "flex-direction-column-sm": "_flex-direction-column-sm_1vxyp_154",
  "flex-direction-column-reverse-sm": "_flex-direction-column-reverse-sm_1vxyp_159",
  "flex-direction-row-md": "_flex-direction-row-md_1vxyp_164",
  "flex-direction-row-reverse-md": "_flex-direction-row-reverse-md_1vxyp_169",
  "flex-direction-column-md": "_flex-direction-column-md_1vxyp_174",
  "flex-direction-column-reverse-md": "_flex-direction-column-reverse-md_1vxyp_179",
  "flex-direction-row-lg": "_flex-direction-row-lg_1vxyp_184",
  "flex-direction-row-reverse-lg": "_flex-direction-row-reverse-lg_1vxyp_189",
  "flex-direction-column-lg": "_flex-direction-column-lg_1vxyp_194",
  "flex-direction-column-reverse-lg": "_flex-direction-column-reverse-lg_1vxyp_199",
  "flex-direction-row-xl": "_flex-direction-row-xl_1vxyp_204",
  "flex-direction-row-reverse-xl": "_flex-direction-row-reverse-xl_1vxyp_209",
  "flex-direction-column-xl": "_flex-direction-column-xl_1vxyp_214",
  "flex-direction-column-reverse-xl": "_flex-direction-column-reverse-xl_1vxyp_219",
  "flex-direction-row-xxl": "_flex-direction-row-xxl_1vxyp_224",
  "flex-direction-row-reverse-xxl": "_flex-direction-row-reverse-xxl_1vxyp_229",
  "flex-direction-column-xxl": "_flex-direction-column-xxl_1vxyp_234",
  "flex-direction-column-reverse-xxl": "_flex-direction-column-reverse-xxl_1vxyp_239",
  "flex-wrap-nowrap": "_flex-wrap-nowrap_1vxyp_243",
  "flex-wrap-wrap": "_flex-wrap-wrap_1vxyp_246",
  "flex-wrap-wrap-reverse": "_flex-wrap-wrap-reverse_1vxyp_249",
  "flex-wrap-nowrap-xs": "_flex-wrap-nowrap-xs_1vxyp_253",
  "flex-wrap-wrap-xs": "_flex-wrap-wrap-xs_1vxyp_258",
  "flex-wrap-wrap-reverse-xs": "_flex-wrap-wrap-reverse-xs_1vxyp_263",
  "flex-wrap-nowrap-sm": "_flex-wrap-nowrap-sm_1vxyp_268",
  "flex-wrap-wrap-sm": "_flex-wrap-wrap-sm_1vxyp_273",
  "flex-wrap-wrap-reverse-sm": "_flex-wrap-wrap-reverse-sm_1vxyp_278",
  "flex-wrap-nowrap-md": "_flex-wrap-nowrap-md_1vxyp_283",
  "flex-wrap-wrap-md": "_flex-wrap-wrap-md_1vxyp_288",
  "flex-wrap-wrap-reverse-md": "_flex-wrap-wrap-reverse-md_1vxyp_293",
  "flex-wrap-nowrap-lg": "_flex-wrap-nowrap-lg_1vxyp_298",
  "flex-wrap-wrap-lg": "_flex-wrap-wrap-lg_1vxyp_303",
  "flex-wrap-wrap-reverse-lg": "_flex-wrap-wrap-reverse-lg_1vxyp_308",
  "flex-wrap-nowrap-xl": "_flex-wrap-nowrap-xl_1vxyp_313",
  "flex-wrap-wrap-xl": "_flex-wrap-wrap-xl_1vxyp_318",
  "flex-wrap-wrap-reverse-xl": "_flex-wrap-wrap-reverse-xl_1vxyp_323",
  "flex-wrap-nowrap-xxl": "_flex-wrap-nowrap-xxl_1vxyp_328",
  "flex-wrap-wrap-xxl": "_flex-wrap-wrap-xxl_1vxyp_333",
  "flex-wrap-wrap-reverse-xxl": "_flex-wrap-wrap-reverse-xxl_1vxyp_338",
  "justify-content-start": "_justify-content-start_1vxyp_342",
  "justify-content-end": "_justify-content-end_1vxyp_345",
  "justify-content-center": "_justify-content-center_1vxyp_348",
  "justify-content-space-between": "_justify-content-space-between_1vxyp_351",
  "justify-content-space-around": "_justify-content-space-around_1vxyp_354",
  "justify-content-space-evenly": "_justify-content-space-evenly_1vxyp_357",
  "justify-content-start-xs": "_justify-content-start-xs_1vxyp_361",
  "justify-content-end-xs": "_justify-content-end-xs_1vxyp_366",
  "justify-content-center-xs": "_justify-content-center-xs_1vxyp_371",
  "justify-content-space-between-xs": "_justify-content-space-between-xs_1vxyp_376",
  "justify-content-space-around-xs": "_justify-content-space-around-xs_1vxyp_381",
  "justify-content-space-evenly-xs": "_justify-content-space-evenly-xs_1vxyp_386",
  "justify-content-start-sm": "_justify-content-start-sm_1vxyp_391",
  "justify-content-end-sm": "_justify-content-end-sm_1vxyp_396",
  "justify-content-center-sm": "_justify-content-center-sm_1vxyp_401",
  "justify-content-space-between-sm": "_justify-content-space-between-sm_1vxyp_406",
  "justify-content-space-around-sm": "_justify-content-space-around-sm_1vxyp_411",
  "justify-content-space-evenly-sm": "_justify-content-space-evenly-sm_1vxyp_416",
  "justify-content-start-md": "_justify-content-start-md_1vxyp_421",
  "justify-content-end-md": "_justify-content-end-md_1vxyp_426",
  "justify-content-center-md": "_justify-content-center-md_1vxyp_431",
  "justify-content-space-between-md": "_justify-content-space-between-md_1vxyp_436",
  "justify-content-space-around-md": "_justify-content-space-around-md_1vxyp_441",
  "justify-content-space-evenly-md": "_justify-content-space-evenly-md_1vxyp_446",
  "justify-content-start-lg": "_justify-content-start-lg_1vxyp_451",
  "justify-content-end-lg": "_justify-content-end-lg_1vxyp_456",
  "justify-content-center-lg": "_justify-content-center-lg_1vxyp_461",
  "justify-content-space-between-lg": "_justify-content-space-between-lg_1vxyp_466",
  "justify-content-space-around-lg": "_justify-content-space-around-lg_1vxyp_471",
  "justify-content-space-evenly-lg": "_justify-content-space-evenly-lg_1vxyp_476",
  "justify-content-start-xl": "_justify-content-start-xl_1vxyp_481",
  "justify-content-end-xl": "_justify-content-end-xl_1vxyp_486",
  "justify-content-center-xl": "_justify-content-center-xl_1vxyp_491",
  "justify-content-space-between-xl": "_justify-content-space-between-xl_1vxyp_496",
  "justify-content-space-around-xl": "_justify-content-space-around-xl_1vxyp_501",
  "justify-content-space-evenly-xl": "_justify-content-space-evenly-xl_1vxyp_506",
  "justify-content-start-xxl": "_justify-content-start-xxl_1vxyp_511",
  "justify-content-end-xxl": "_justify-content-end-xxl_1vxyp_516",
  "justify-content-center-xxl": "_justify-content-center-xxl_1vxyp_521",
  "justify-content-space-between-xxl": "_justify-content-space-between-xxl_1vxyp_526",
  "justify-content-space-around-xxl": "_justify-content-space-around-xxl_1vxyp_531",
  "justify-content-space-evenly-xxl": "_justify-content-space-evenly-xxl_1vxyp_536",
  "align-items-start": "_align-items-start_1vxyp_540",
  "align-items-end": "_align-items-end_1vxyp_543",
  "align-items-center": "_align-items-center_1vxyp_546",
  "align-items-stretch": "_align-items-stretch_1vxyp_549",
  "align-items-baseline": "_align-items-baseline_1vxyp_552",
  "align-items-start-xs": "_align-items-start-xs_1vxyp_556",
  "align-items-end-xs": "_align-items-end-xs_1vxyp_561",
  "align-items-center-xs": "_align-items-center-xs_1vxyp_566",
  "align-items-stretch-xs": "_align-items-stretch-xs_1vxyp_571",
  "align-items-baseline-xs": "_align-items-baseline-xs_1vxyp_576",
  "align-items-start-sm": "_align-items-start-sm_1vxyp_581",
  "align-items-end-sm": "_align-items-end-sm_1vxyp_586",
  "align-items-center-sm": "_align-items-center-sm_1vxyp_591",
  "align-items-stretch-sm": "_align-items-stretch-sm_1vxyp_596",
  "align-items-baseline-sm": "_align-items-baseline-sm_1vxyp_601",
  "align-items-start-md": "_align-items-start-md_1vxyp_606",
  "align-items-end-md": "_align-items-end-md_1vxyp_611",
  "align-items-center-md": "_align-items-center-md_1vxyp_616",
  "align-items-stretch-md": "_align-items-stretch-md_1vxyp_621",
  "align-items-baseline-md": "_align-items-baseline-md_1vxyp_626",
  "align-items-start-lg": "_align-items-start-lg_1vxyp_631",
  "align-items-end-lg": "_align-items-end-lg_1vxyp_636",
  "align-items-center-lg": "_align-items-center-lg_1vxyp_641",
  "align-items-stretch-lg": "_align-items-stretch-lg_1vxyp_646",
  "align-items-baseline-lg": "_align-items-baseline-lg_1vxyp_651",
  "align-items-start-xl": "_align-items-start-xl_1vxyp_656",
  "align-items-end-xl": "_align-items-end-xl_1vxyp_661",
  "align-items-center-xl": "_align-items-center-xl_1vxyp_666",
  "align-items-stretch-xl": "_align-items-stretch-xl_1vxyp_671",
  "align-items-baseline-xl": "_align-items-baseline-xl_1vxyp_676",
  "align-items-start-xxl": "_align-items-start-xxl_1vxyp_681",
  "align-items-end-xxl": "_align-items-end-xxl_1vxyp_686",
  "align-items-center-xxl": "_align-items-center-xxl_1vxyp_691",
  "align-items-stretch-xxl": "_align-items-stretch-xxl_1vxyp_696",
  "align-items-baseline-xxl": "_align-items-baseline-xxl_1vxyp_701"
}, S = [
  "row",
  "row-reverse",
  "column",
  "column-reverse"
], T = ["nowrap", "wrap", "wrap-reverse"], k = [
  "start",
  "end",
  "center",
  "space-around",
  "space-between",
  "space-evenly"
], q = [
  "start",
  "end",
  "center",
  "stretch",
  "baseline"
], z = [
  "start",
  "end",
  "center",
  "stretch",
  "space-around",
  "space-between"
], h = j.forwardRef(
  ({
    display: l = "flex",
    direction: p,
    wrap: i,
    justifyContent: a,
    alignItems: o,
    alignContent: c,
    gap: _,
    rowGap: s,
    columnGap: x,
    asChild: y,
    children: v,
    className: m,
    ...f
  }, g) => {
    const u = d(
      t(n("flex-direction", p), e),
      t(n("flex-wrap", i), e),
      t(n("justify-content", a), e),
      t(n("align-items", o), e),
      t(n("align-content", c), e),
      {
        [e[`gap-${_}`]]: _,
        [e[`row-gap-${s}`]]: s,
        [e[`column-gap-${x}`]]: x
      },
      m
    );
    return /* @__PURE__ */ r(
      b,
      {
        className: u,
        ...f,
        display: l,
        ref: g,
        asChild: !0,
        children: /* @__PURE__ */ r(y ? w : "div", { children: v })
      }
    );
  }
);
h.displayName = "Flex";
export {
  h as Flex,
  z as alignContent,
  q as alignItems,
  S as directions,
  k as justifyContent,
  T as wrap
};
//# sourceMappingURL=flex.js.map
